import SlotPicker from "@/components/SlotPicker";
import { facetExamples } from "@/content/facetExamples";
import { useJamSelectionStore, jamAxes } from "@/store/jamSelectionStore";
import { useConceptAxes } from "@/store/customContentStore";

/** Wires the generic SlotPicker to the Game-Jam selection store. */
export default function JamSlotPicker() {
  const s = useJamSelectionStore();
  // useConceptAxes() subscribes to concept changes; jamAxes() prepends "twist".
  useConceptAxes();
  const axes = jamAxes();
  const order = axes.map((a) => a.key);
  const labels = Object.fromEntries(axes.map((a) => [a.key, a.label]));
  const pools = Object.fromEntries(axes.map((a) => [a.key, a.values]));

  return (
    <SlotPicker
      order={order}
      labels={labels}
      pools={pools}
      unit="slots"
      valueExamples={facetExamples}
      isEnabled={s.isAxisEnabled}
      isValueOn={s.isValueOn}
      activeCount={s.activeCount}
      activeAxisCount={s.activeAxisCount()}
      onToggleAxis={s.toggleAxis}
      onToggleValue={s.toggleValue}
      onSetAxisValues={s.setAxisValues}
      onEnableAll={s.enableAll}
      onDisableAll={s.disableAll}
      onReset={s.resetAll}
    />
  );
}
